import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface YoutubePlayProps extends IconWrapperProps {
  onClick?: () => void;
  color?: string;
  height: string;
  shadow?: boolean;
  uniqueId?: string;
  className?: string;
}

const YoutubePlay = ({
  onClick,
  color = 'currentColor',
  height,
  shadow,
  uniqueId,
  className,
  ...rest
}: YoutubePlayProps) => {
  const uniqueVal = uniqueId || Math.floor(100000 + Math.random() * 900000);
  const filterId = `filter-${uniqueVal}`;
  const pathId = `pathId-${uniqueVal}`;

  if (shadow) {
    return (
      <span onClick={onClick} className={className}>
        <IconWrapper
          viewBox="0 0 94 94"
          disableSize
          className="max-w-full"
          style={{ height }}
          title="Play Video"
          {...rest}
        >
          <defs>
            <filter
              x="-16.0%"
              y="-16.0%"
              width="132.0%"
              height="132.0%"
              filterUnits="objectBoundingBox"
              id={filterId}
            >
              <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
              <feColorMatrix
                values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.752321897 0"
                type="matrix"
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <path
              d="M37.5,75 C58.126935,75 75,58.1356369 75,37.4806601 C75,16.8643631 58.126935,0 37.5,0 C16.873065,0 0,16.8643631 0,37.4806601 C0,58.1356369 16.873065,75 37.5,75 Z M37.5,73.1046931 C17.879257,73.1046931 1.89628483,57.1299639 1.89628483,37.4806601 C1.89628483,17.8700361 17.879257,1.89530686 37.5,1.89530686 C57.1594427,1.89530686 73.1037152,17.8700361 73.1037152,37.4806601 C73.1037152,57.1299639 57.1594427,73.1046931 37.5,73.1046931 Z M29.7987616,52.6044353 C28.5603715,53.3393502 27.0897833,52.7204745 27.0897833,51.4440433 L27.0897833,23.4399175 C27.0897833,22.1634863 28.5603715,21.5446106 29.7987616,22.2795255 L52.0510836,35.9334709 C53.3281734,36.7070655 53.3281734,38.3316142 52.0510836,39.1052089 L29.7987616,52.6044353 Z"
              id={pathId}
            />
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              filter={shadow ? `url(#${filterId})` : undefined}
              transform="translate(10.000000, 10.000000)"
            >
              <mask fill={color}>
                <use xlinkHref={`#${pathId}`} />
              </mask>
              <use fill={color} fillRule="nonzero" xlinkHref={`#${pathId}`} />
            </g>
          </g>
        </IconWrapper>
      </span>
    );
  }

  return (
    <span onClick={onClick} className={className}>
      <IconWrapper
        viewBox="0 0 312.35 299.6"
        title="Play Video"
        className="max-w-full"
        style={{ height }}
        {...rest}
      >
        <path
          fill={color}
          d="M336.94,164c2.58,69.36-60.68,132.29-130.37,142.82-44.27,6.69-84.8-2.48-120.35-29.06-38.08-28.46-60.28-66.12-61.5-115.13-1-41.46,13.52-76.59,41.7-105.76,24.07-24.91,54-39.95,88.66-45.33,51.44-8,96.92,5.7,134.88,40.29C320.76,79.88,337.31,115.8,336.94,164ZM183.63,300.56c16.9-1,37.61-4.19,57.11-12.78,50.19-22.11,86.43-68.47,87.46-126.43.73-41.1-15.32-75.72-45.91-103.59-37.67-34.31-81.73-45.38-131.22-36.52-31.66,5.67-58,21.12-79.91,44.68-31.57,34-43.94,73.82-35,119.09C49.49,253,111,298.86,183.63,300.56Z"
          transform="translate(-24.67 -9.31)"
        />
        <path
          fill={color}
          d="M137.29,158.1c0-16.6-.14-33.2,0-49.8.12-11,4.79-13.79,14.42-8.18q43.38,25.27,86.46,51.06c10,6,9.69,10-.48,15.92q-41.08,24.06-82.18,48.13c-4.73,2.75-9.83,6.44-15.41,3-5.06-3.12-2.67-8.85-2.74-13.43C137.15,189.23,137.3,173.66,137.29,158.1Z"
          transform="translate(-24.67 -9.31)"
        />
      </IconWrapper>
    </span>
  );
};

export default memo(YoutubePlay);
